import Marquee from "react-fast-marquee";
import { marquee } from "../content/site";

export default function EditorialMarquee({ dark = false }) {
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y py-6 ${
        dark ? "border-cream/10 bg-navy" : "border-brass/25 bg-cream-200"
      }`}
    >
      <Marquee speed={32} gradient={false} autoFill>
        {marquee.map((word, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`px-8 font-serif text-3xl italic sm:text-4xl ${
                dark ? "text-cream" : "text-navy"
              }`}
            >
              {word}
            </span>
            <span className="text-brass">&bull;</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
